import { render, staticRenderFns } from "./PersonProfileHistoryMatchingInformation.vue?vue&type=template&id=6c216302&scoped=true&"
import script from "./PersonProfileHistoryMatchingInformation.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryMatchingInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryMatchingInformation.vue?vue&type=style&index=0&id=6c216302&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c216302",
  null
  
)

export default component.exports